import Phaser from 'phaser';
import * as ABCya from '@abcya/abcya_phaser';
import gameData from '../gameData';
import { sameDoubleRow ,differentDoubleRow, generateSingleRowContent } from './inGame/questionGenerators.js';
import { displayDonuts } from './inGame/displayQuestionParts';
import { listenerSetup, selectorUpdateLoop } from './inGame/donutClickHandlers';
import { menuUI } from './inGame/menuUI';
import { createTitle } from './inGame/createTitle';
//import { makeMask } from './inGame/biteMask';
import { createParticle } from './inGame/sprinkleParticle';
import { makeDonutStart } from './makeADonut/makeDonutStart';
import { sounds } from './inGame/sounds';
import sKey from '../SoundAssetKeys';
import { finalScreen } from './makeADonut/finalScreen';
import { eatDonut } from './makeADonut/eatDonut';

export default class Game extends Phaser.Scene
{
    static get KEY() { return 'Game'; }

    create()
    {
        const skipIntro = false;
        this.sprinkleCont = this.add.container();
        this.sprinkleCont.setDepth(5);
        this.makeDonut = ABCya.Images.addImage(512,405,`Donuts and Sprinkles/Donut_Ring_Plain`,this).setDepth(4).setAlpha(0);
    
        this.rend = this.add.graphics();
        this.rend.beginPath();
        this.rend.fillStyle(0xff00ff, 1);

        this.rendMask = this.rend.createGeometryMask();
        //this.makeDonut = ABCya.Images.addImage(512,405,`Donuts and Sprinkles/Donut_Star_Plain`,this).setDepth(4).setAlpha(1);
        this.maskedBack = ABCya.Images.addImage(512,384,"Background-01",this).setDepth(5).setMask(this.rendMask);
        this.back = ABCya.Images.addImage(512,384,"Background-01",this);
        this.selector1 = ABCya.Images.addImage(512,0,"General UI/Selected_Heart",this).setScale(gameData.donutScale).setAlpha(0).setDepth(4);
        this.selector2 = ABCya.Images.addImage(512,0,"General UI/Selected_Heart",this).setScale(gameData.donutScale).setAlpha(0).setDepth(4);

        this.questionText = this.add.text(512,213,"",{
            fontFamily:'bpreplaybold',
            fontSize:'40px',
            align:'center',
            color:'#0099ad'
        }).setOrigin(.5,.5);
        this.correctX = ABCya.Images.addImage(512,631,"General UI/Correct_Check",this).setAlpha(0).setDepth(5);
        this.incorrectX = ABCya.Images.addImage(512,647,"General UI/Incorrect_X",this).setAlpha(0).setDepth(5);
        this.part = createParticle(this);
        Phaser.Math.RND.shuffle(gameData.sprinkleNums.arr);
        
        //*******Mask stuff for possible bite transistion out of title */
        // this.rend = makeMask(this);

        // this.mask = this.rend.createBitmapMask();
        // this.mask.invertAlpha = true;

        // const donut = ABCya.Images.addImage(510, 308, "Title Screen/Logo_Donut",this).setDepth(3);
        // donut.setMask(this.mask);

        //createTitle(this);

        if(!gameData.started)
        {
            this.custSound = sounds(this);
            this.custSound.playSoundCustom(sKey._jingle_same_different,.8,true);
            listenerSetup(this);
            createSizeMap(this);
            gameData.started = true;
        }
       
        if(!skipIntro) 
        {
            createAllLayouts();
            createTitle(this);
        }

        else
        {
            // eatDonut(this)
            async function skip(scene)
            {
                await createAllLayouts()
                displayDonuts(gameData.layouts[gameData.questionNum], scene);
                menuUI(scene);
            }
            skip(this)
        }

        this.back.setInteractive();

        async function createAllLayouts()
        {

            return new Promise(async (resolve) => {
                const qText = gameData.questionText;

                gameData.layouts = [
                    {displayObj:generateSingleRowContent("shape","same"),question:qText.same+qText.shape,type: "same"},
                    {displayObj:generateSingleRowContent("shape","same"),question:qText.same+qText.shape,type: "same"},
                    {displayObj:generateSingleRowContent("shape","different"),question:qText.differ+qText.shape,type:"different"},
                    {displayObj:generateSingleRowContent("shape","different"),question:qText.differ+qText.shape,type:"different"},
                    {displayObj:generateSingleRowContent("color","same"),question:qText.same+qText.color,type: "same"},
                    {displayObj:generateSingleRowContent("color","same"),question:qText.same+qText.color,type: "same"},
                    {displayObj:generateSingleRowContent("color","different"),question:qText.differ+qText.color,type:"different"},
                    {displayObj:generateSingleRowContent("color","different"),question:qText.differ+qText.color,type:"different"},
                ];

                await sameDoubleRow().then(async (displayObj1)=>{
                    await sameDoubleRow().then((displayObj2)=>{
                        gameData.layouts.push({displayObj: displayObj1,question:qText.same+qText.shapeColor,type: "same"});
                        gameData.layouts.push({displayObj: displayObj2,question:qText.same+qText.shapeColor,type: "same"});
                        gameData.layouts.push({displayObj: differentDoubleRow(),question:qText.differ+qText.shapeColor,type:"different"});
                        gameData.layouts.push({displayObj: differentDoubleRow(),question:qText.differ+qText.shapeColor,type:"different"});
                    });
                });
                
                resolve();
            });
        }
        
        function createSizeMap(Scene)
        {
            gameData.sizeMap = new Map;

            for(let each in gameData.shapes)
            {
                //const frameName = `Donuts and Sprinkles/Donut_${gameData.shapes[each]}_Black`;
                let shape = gameData.shapes[each];
                if(shape === "Ring") shape = "Round";
                const frameName = `General UI/Selected_${shape}`;
                const displayWidth = Scene.textures.list.UIAssets.frames[frameName].width * gameData.donutScale;

                //console.log(gameData.shapes[each],displayWidth);

                gameData.sizeMap.set(gameData.shapes[each],displayWidth);
            }
        }
    }
}